import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { mapToVoid } from '@examdojo/rxjs';
import { of, take } from 'rxjs';
import { ClassQuery } from '../class/class.query';
import { ClassAssignmentService } from './class-assignment.service';

export const classAssignmentResolver: ResolveFn<void> = () => {
  const classAssignmentService = inject(ClassAssignmentService);
  const classQuery = inject(ClassQuery);
  const errorHandlerService = inject(ErrorHandlerService);

  const classId = classQuery.getActiveId() || undefined;

  return classAssignmentService.init(classId).pipe(
    errorHandlerService.catchHttpErrors(() => of(undefined)),
    take(1),
    mapToVoid(),
  );
};
